/**
  * Capitalize a string
  * @param {String} str
  * @returns {String}
  */
export const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);

/**
 * Convert a data uri string into a blob
 *
 * Source: https://gist.github.com/fupslot/5015897
 *
 * @param {String} dataUri
 * @returns {Blob}
 */
export const dataUriToBlob = dataUri => {
  const byteString = atob(dataUri.split(',')[1]);

  // separate out the mime component
  const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to an ArrayBuffer
  const arrayBuffer = new ArrayBuffer(byteString.length);

  // create a view into the buffer
  let ia = new Uint8Array(arrayBuffer);

  // set the bytes of the buffer to the correct values
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob
  return new Blob([arrayBuffer], { type: mimeString });
};
